var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.switchOperate}},[_c('img',{attrs:{"src":_vm.switchVal
        ? require('@/assets/images/my/manageLogin/switch2.png')
        : require('@/assets/images/my/manageLogin/switch1.png'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }